import React from "react";
import GeneralRules from "../../features/icgeneralrules";

const HouseRulesGeneralPage = () => <GeneralRules />

export default HouseRulesGeneralPage;